import gql from "graphql-tag";

export const CREATE_TEMPLATE_COSTUME_VALUE = gql`
  mutation CreateCostumeValue($data: CostumeValueCreateInput!) {
    createCostumeValue(data: $data) {
      id
    }
  }
`;
